import { jsx as _jsx } from "react/jsx-runtime";
import { createBrowserRouter } from "react-router-dom";
import { PATHS } from "./paths";
import { AuthLayout } from "@/components/layouts/AuthLayout";
import { ProtectedLayout } from "@/components/layouts/ProtectedLayout";
import { AdminGuard } from "@/components/layouts/AdminGuard";
import { SignInPage } from "@/pages/auth/SignInPage";
import { TicketListPage } from "@/pages/tickets/TicketListPage";
import { TicketCreatePage } from "@/pages/tickets/TicketCreatePage";
import { TicketDetailPage } from "@/pages/tickets/TicketDetailPage";
import { AdminDashboard } from "@/pages/admin/AdminDashboard";
import { UserManagement } from "@/pages/admin/UserManagement";
export const router = createBrowserRouter([
    {
        element: _jsx(AuthLayout, {}),
        children: [
            {
                path: PATHS.SIGN_IN,
                element: _jsx(SignInPage, {}),
            },
        ],
    },
    {
        element: _jsx(ProtectedLayout, {}),
        children: [
            {
                path: PATHS.TICKETS,
                element: _jsx(TicketListPage, {}),
            },
            {
                path: PATHS.TICKET_CREATE,
                element: _jsx(TicketCreatePage, {}),
            },
            {
                path: PATHS.TICKET_DETAIL,
                element: _jsx(TicketDetailPage, {}),
            },
            {
                element: _jsx(AdminGuard, {}),
                children: [
                    {
                        path: PATHS.ADMIN_DASHBOARD,
                        element: _jsx(AdminDashboard, {}),
                    },
                    {
                        path: PATHS.ADMIN_USERS,
                        element: _jsx(UserManagement, {}),
                    },
                ],
            },
        ],
    },
]);
